import { GiftBoxResponse, GiftCouponStatus } from '@models/gift';

/** SENT(발송 완료)는 받은 사람 입장에서 사용 가능한 쿠폰이라 ISSUED로 본다. */
export function getReceivedCouponStatus(
    giftBox: GiftBoxResponse,
): GiftCouponStatus | undefined {
    const status = giftBox.giftCoupon?.status;
    return status === GiftCouponStatus.SENT ? GiftCouponStatus.ISSUED : status;
}

export function getReceivedSenderName(
    giftBox: GiftBoxResponse,
    selfLabel: string,
): string {
    if (giftBox.isSentToSelf) return selfLabel;
    return giftBox.senderName || '-';
}
